import axios from "axios"

let logoutCallback = null

export const setLogoutCallback = (callback) => {
    logoutCallback = callback
}

const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
    (res) => res,
    (error) => {
        const { logout, tokenType, adminlogin } = error.response?.data || {}
        if (logout) {
            if (logoutCallback) logoutCallback((tokenType && adminlogin) ? 'adminToken' : 'userToken')
        }
        return Promise.reject(error)
    }
)

export default axiosInstance

